var map = {
	"./Inbox.svg": 533,
	"./app-menu.svg": 534,
	"./armchair-fill.svg": 535,
	"./armchair.svg": 536,
	"./arrow-down-fill.svg": 537,
	"./arrow-down.svg": 538,
	"./arrow-left-fill.svg": 539,
	"./arrow-left.svg": 540,
	"./arrow-right-fill.svg": 541,
	"./arrow-right.svg": 542,
	"./arrow-up-fill.svg": 543,
	"./arrow-up.svg": 544,
	"./arrows-in-fill.svg": 545,
	"./arrows-in.svg": 546,
	"./attach.svg": 547,
	"./bank-fill.svg": 548,
	"./bank.svg": 549,
	"./barricade-fill.svg": 550,
	"./barricade.svg": 551,
	"./bath-fill.svg": 552,
	"./bath.svg": 553,
	"./bed-fill.svg": 554,
	"./bed.svg": 555,
	"./bell-fill.svg": 556,
	"./bell.svg": 557,
	"./bicycle-fill.svg": 558,
	"./bicycle.svg": 559,
	"./book.svg": 560,
	"./box-fill.svg": 561,
	"./box.svg": 562,
	"./brush-fill.svg": 563,
	"./brush.svg": 564,
	"./buildings-fill.svg": 565,
	"./buildings.svg": 566,
	"./calendar-check-fill.svg": 567,
	"./calendar-check.svg": 568,
	"./calendar-cross-fill.svg": 569,
	"./calendar-cross.svg": 570,
	"./calendar-fill.svg": 571,
	"./calendar.svg": 572,
	"./car-fill.svg": 573,
	"./car.svg": 574,
	"./cart-fill.svg": 575,
	"./cart.svg": 576,
	"./chart-column-fill.svg": 577,
	"./chart-column.svg": 578,
	"./chart-line-fill.svg": 579,
	"./chart-line.svg": 580,
	"./chart-pie-fill.svg": 581,
	"./chart-pie.svg": 582,
	"./chat-fill.svg": 583,
	"./chat.svg": 584,
	"./check.svg": 585,
	"./clipboard-fill.svg": 586,
	"./clipboard-text-fill.svg": 587,
	"./clipboard-text.svg": 588,
	"./clipboard.svg": 589,
	"./clock-clockwise-fill.svg": 590,
	"./clock-clockwise.svg": 591,
	"./clock-counter-clockwise-fill.svg": 592,
	"./clock-counter-clockwise.svg": 593,
	"./clock-fill.svg": 594,
	"./clock.svg": 595,
	"./close.svg": 596,
	"./coins-fill.svg": 597,
	"./coins.svg": 598,
	"./cone-fill.svg": 599,
	"./cone.svg": 600,
	"./cross.svg": 601,
	"./cursor-fill.svg": 602,
	"./cursor.svg": 603,
	"./dashboard-fill.svg": 604,
	"./dashboard.svg": 605,
	"./desktop-fill.svg": 606,
	"./desktop.svg": 607,
	"./diamond-fill.svg": 608,
	"./diamond.svg": 609,
	"./dog-fill.svg": 610,
	"./dog.svg": 611,
	"./door-fill.svg": 612,
	"./door.svg": 613,
	"./download-fill.svg": 614,
	"./download.svg": 615,
	"./earth-fill.svg": 616,
	"./earth.svg": 617,
	"./error-fill.svg": 618,
	"./error.svg": 619,
	"./exit.svg": 620,
	"./face-happy-fill.svg": 621,
	"./face-happy.svg": 622,
	"./face-neutral-fill.svg": 623,
	"./face-neutral.svg": 624,
	"./face-sad-fill.svg": 625,
	"./face-sad.svg": 626,
	"./filter.svg": 627,
	"./fingerprint.svg": 628,
	"./flag-fill.svg": 629,
	"./flag.svg": 630,
	"./flower-fill.svg": 631,
	"./flower.svg": 632,
	"./fork-fill.svg": 633,
	"./fork.svg": 634,
	"./funnel-fill.svg": 635,
	"./funnel.svg": 636,
	"./gear-fill.svg": 637,
	"./gear.svg": 638,
	"./globe-fill.svg": 639,
	"./globe.svg": 640,
	"./hamburger.svg": 641,
	"./handshake-fill.svg": 642,
	"./handshake.svg": 643,
	"./heart-fill.svg": 644,
	"./heart.svg": 645,
	"./help-fill.svg": 646,
	"./help.svg": 647,
	"./home-fill.svg": 648,
	"./home.svg": 649,
	"./inbox-fill.svg": 650,
	"./info-fill.svg": 651,
	"./info.svg": 652,
	"./key-fill.svg": 653,
	"./key.svg": 654,
	"./layers-fill.svg": 655,
	"./layers-simple-fill.svg": 656,
	"./layers-simple.svg": 657,
	"./layers.svg": 658,
	"./layout-fill.svg": 659,
	"./layout.svg": 660,
	"./leaf-fill.svg": 661,
	"./leaf.svg": 662,
	"./lock-fill.svg": 663,
	"./lock.svg": 664,
	"./mail-fill.svg": 665,
	"./mail.svg": 666,
	"./map-fill.svg": 667,
	"./map.svg": 668,
	"./megaphone-fill.svg": 669,
	"./megaphone.svg": 670,
	"./menu-dotted.svg": 671,
	"./minus.svg": 672,
	"./money-fill.svg": 673,
	"./money.svg": 674,
	"./monitor-fill.svg": 675,
	"./monitor.svg": 676,
	"./motorcycle-fill.svg": 677,
	"./motorcycle.svg": 678,
	"./open.svg": 679,
	"./options-fill.svg": 680,
	"./options.svg": 681,
	"./paint-fill.svg": 682,
	"./paint.svg": 683,
	"./palette-fill.svg": 684,
	"./palette.svg": 685,
	"./paw-fill.svg": 686,
	"./paw.svg": 687,
	"./pencil-line-fill.svg": 688,
	"./pencil-line.svg": 689,
	"./pencil-simple-line-fill.svg": 690,
	"./pencil-simple-line.svg": 691,
	"./phone-fill.svg": 692,
	"./phone.svg": 693,
	"./pin-fill.svg": 694,
	"./pin.svg": 695,
	"./plan-fill.svg": 696,
	"./plan.svg": 697,
	"./play-circle-fill.svg": 698,
	"./play-circle.svg": 699,
	"./play-fill.svg": 700,
	"./play.svg": 701,
	"./plus.svg": 702,
	"./pot-fill.svg": 703,
	"./pot.svg": 704,
	"./push-pin-fill.svg": 705,
	"./push-pin-off-fill.svg": 706,
	"./push-pin-off.svg": 707,
	"./push-pin.svg": 708,
	"./question-mark-fill.svg": 709,
	"./question-mark.svg": 710,
	"./ruler-fill.svg": 711,
	"./ruler.svg": 712,
	"./search-fill.svg": 713,
	"./search.svg": 714,
	"./sign-out.svg": 715,
	"./size-fill.svg": 716,
	"./size.svg": 717,
	"./sparkle-fill.svg": 718,
	"./sparkle.svg": 719,
	"./square-fill.svg": 720,
	"./square-half-fill.svg": 721,
	"./square-half.svg": 722,
	"./square.svg": 723,
	"./sun-fill.svg": 724,
	"./sun.svg": 725,
	"./table-fill.svg": 726,
	"./table.svg": 727,
	"./tablet-fill.svg": 728,
	"./tablet.svg": 729,
	"./trash-fill.svg": 730,
	"./trash.svg": 731,
	"./tree-fill.svg": 732,
	"./tree.svg": 733,
	"./unlock-fill.svg": 734,
	"./unlock.svg": 735,
	"./upload-fill.svg": 736,
	"./upload.svg": 737,
	"./user-circle-fill.svg": 738,
	"./user-circle.svg": 739,
	"./user-fill.svg": 740,
	"./user.svg": 741,
	"./users-fill.svg": 742,
	"./users.svg": 743,
	"./view-fill.svg": 744,
	"./view-off-fill.svg": 745,
	"./view-off.svg": 746,
	"./view.svg": 747,
	"./wallet-fill.svg": 748,
	"./wallet.svg": 749,
	"./warning-fill.svg": 750,
	"./warning.svg": 751,
	"./zoom-minus-fill.svg": 752,
	"./zoom-minus.svg": 753,
	"./zoom-plus-fill.svg": 754,
	"./zoom-plus.svg": 755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 532;